export default {
  table: {
    name: "Role Name",
    remark: "Remark",
    createBy: "Created By",
    updateBy: "Updated By",
    createAt: "Created At",
    updatedAt: "Updated At",
    menuPermissions: "Menu Permissions",
    isAdministrator: "Is Admin",
  },
  form: {
    name: "Role",
    administrator: "Admin",
  },
};
